/* eslint-disable no-loop-func */
/* eslint-disable no-undef */

import {
  CLEAR_LISTING_ERROR,
  CREATE_LISTING_FAILED,
  CREATE_LISTING_START,
  CREATE_LISTING_SUCCESS,
  DELETE_LISTING_FAILED,
  DELETE_LISTING_START,
  DELETE_LISTING_SUCCESS,
  DELETE_PDF_FAILED,
  DELETE_PDF_START,
  DELETE_PDF_SUCCESS,
  FETCH_LISTING_BY_BRANCH_SUCCESS,
  FETCH_LISTING_FAILED,
  FETCH_LISTING_START,
  FETCH_LISTING_SUCCESS,
  GENERATE_PDF_START,
  GENERATE_PDF_SUCCESS,
  GENERATE_PDF_FAILED,
  LISTING_ERROR,
  UPDATE_LISTING_FAILED,
  UPDATE_LISTING_START,
  UPDATE_LISTING_SUCCESS,
  UPDATE_PULLFORWARD_LISTING_SUCCESS,
  UPDATE_LISTING_INFO_FAILED,
  UPDATE_LISTING_INFO_SUCCESS,
  UPDATE_LISTING_INFO_START,
  CLEAR_LISTING_INFO_ERROR,
  DUPLICATE_LISTING_START,
  DUPLICATE_LISTING_SUCCESS,
  DUPLICATE_LISTING_FAILED
} from "../store/types";
import {//
  cloud_function_server_url,
} from "config";

 //!!this must be commented when wanting to do a yarn common
//import { printToFileAsync } from "expo-print";
//import { Linking } from "react-native";


export const getFileUrl = () => (firebase) => {
  const { apiLogoRef } = firebase;
  try {
    const url = apiLogoRef().getDownloadURL();
    console.log('Download URL:', url);
    return url;
  } catch (error) {
    console.error('Error getting download URL:', error);
    throw error;
  }
}

export const clearListingErrors = () => (dispatch) => (firebase) => {
  dispatch({
    type: CLEAR_LISTING_ERROR,
    payload: null,
  });
};

export const clearListingErrorsPrimary = () => (dispatch) => (firebase) => {
  dispatch({
    type: CLEAR_LISTING_INFO_ERROR,
  });
};

export const fetchListingInArea = () => (dispatch) => (firebase) => { };

export const fetchAllListings = () => (dispatch) => (firebase) => {
  const { ListingRef, auth } = firebase;
  try {
    dispatch({
      type: FETCH_LISTING_START,
      payload: null,
    });

    ListingRef.on("value", (snapshot) => {
      let ListingHistory = snapshot.val();
      if (ListingHistory) {
        //converting data from database to an array to be used in the app
        let EnquiriesHistoryKeys = Object.keys(ListingHistory);
        let EnquiriesHistoryData = Object.values(ListingHistory);

        for (let index = 0; index < EnquiriesHistoryData.length; index++) {
          //putting the id into the object of all the element of the array
          EnquiriesHistoryData[index] = {
            ...EnquiriesHistoryData[index],
            id: EnquiriesHistoryKeys[index],
          };
        }

        dispatch({
          type: FETCH_LISTING_SUCCESS,
          payload: EnquiriesHistoryData,
        });
      } else {
        dispatch({
          type: FETCH_LISTING_FAILED,
          payload: `No data found`,
        });
      }
    });
  } catch (error) {
    dispatch({
      type: LISTING_ERROR,
      payload: `Sorry we recieved an error ,\n ${error.code} : ${error.message}`,
    });
  }
};

export const RemovePullforwardListingsForAll =
  (UpdatedListingData) => (dispatch) => (firebase) => {
    //Please send the full listing object with the update data and the data that was not updated
    const { singleListingRef, auth, api, EnquiryRef } = firebase;
    dispatch({
      type: UPDATE_LISTING_START,
      payload: null,
    });
    try {
      if (UpdatedListingData) {
        singleListingRef(UpdatedListingData?.id)
          .set(UpdatedListingData)
          .then(() => {
            dispatch({
              type: UPDATE_PULLFORWARD_LISTING_SUCCESS,
              payload: UpdatedListingData,
              msg: "Listing has been removed from pull forward"
            });
          })
          .catch((error) => {
            dispatch({
              type: LISTING_ERROR,
              payload: `Sorry we recieved an error ,\n ${error.code} : ${error.message}`,
            });
          });
      } else {
        dispatch({
          type: UPDATE_LISTING_FAILED,
          payload: "Please double check inputted data",
        });
      }
    } catch (error) {
      dispatch({
        type: ENQUIRY_ERROR,
        payload: error,
      });
    }
  };

export const fetchCurrentAdminsBranchListings =
  () => (dispatch) => (firebase) => {
    const { ListingOfficeRef, auth } = firebase;
    try {
      dispatch({
        type: FETCH_LISTING_START,
        payload: null,
      });

      let activeListings = [];
      let inactiveListings = [];
      let collectiveListings = { activeListings, inactiveListings };

      console.log(
        `Logged in user office: ${auth.currentUser.profile.adminHomeOffice}`
      );

      ListingOfficeRef(
        auth.currentUser.profile.adminHomeOffice
          ? auth.currentUser.profile.adminHomeOffice
          : auth.currentUser.profile.brokerHomeOffice
      ).once("value", (snapshot) => {
        if (snapshot.val()) {
          console.log(`got snapshot`);
          let listingdataArr = Object.entries(snapshot.val());
          console.log("listingdataArr.length", listingdataArr.length);
          for (let index = 0; index < listingdataArr.length; index++) {
            const listing = listingdataArr[index][1];
            const listingId = listingdataArr[index][0];

            if (
              listing &&
              (listing.status === "Active" ||
                (listing?.archive && listing?.archive > new Date().getTime()))
            ) {
              //sorting enquiries into different arrays based on their status
              activeListings.push({
                ...listing,
                id: listingId,
              });
            } else {
              inactiveListings.push({
                ...listing,
                id: listingId,
              });
            }

            if (
              //checking if we have reached the end of the arrays
              index ===
              listingdataArr.length - 1
            ) {
              console.log(
                `Active: ${activeListings.length} : inactive: ${JSON.stringify(
                  inactiveListings.length
                )}`
              );

              collectiveListings = {
                activeListings: activeListings.sort((a, b) => {
                  let dateA = a.CreatedAt;
                  let dateB = b.CreatedAt;

                  return dateB - dateA; //For descending order
                }),

                inactiveListings: inactiveListings.sort((a, b) => {
                  let dateA = a.CreatedAt;
                  let dateB = b.CreatedAt;

                  return dateB - dateA; //For descending order
                }),
              };
            }
          }
          dispatch({
            type: FETCH_LISTING_BY_BRANCH_SUCCESS,
            payload: collectiveListings,
          });
        } else {
          dispatch({
            type: FETCH_LISTING_BY_BRANCH_SUCCESS,
            payload: collectiveListings,
          });
        }
      });
    } catch (error) {
      dispatch({
        type: LISTING_ERROR,
        payload: `Sorry we recieved an error ,\n ${error.code} : ${error.message}`,
      });
    }
  };

export const fetchAllBranchListings = (branch) => (dispatch) => (firebase) => {
  const { ListingOfficeRef, auth } = firebase;
  try {
    dispatch({
      type: FETCH_LISTING_START,
      payload: null,
    });

    let activeListings = [];
    let inactiveListings = [];
    let collectiveListings = { activeListings, inactiveListings };

    console.log(
      `Logged in user office: ${auth.currentUser.profile.adminHomeOffice}`
    );

    ListingOfficeRef(branch).once("value", (snapshot) => {
      if (snapshot.val()) {
        console.log(`got snapshot`);
        let listingdataArr = Object.entries(snapshot.val());
        console.log("listingdataArr.length", listingdataArr.length);
        for (let index = 0; index < listingdataArr.length; index++) {
          const listing = listingdataArr[index][1];
          const listingId = listingdataArr[index][0];

          if (
            listing &&
            (listing.status === "Active" ||
              (listing?.archive && listing?.archive > new Date().getTime()))
          ) {
            //sorting enquiries into different arrays based on their status
            activeListings.push({
              ...listing,
              id: listingId,
            });
          } else {
            inactiveListings.push({
              ...listing,
              id: listingId,
            });
          }

          if (
            //checking if we have reached the end of the arrays
            index ===
            listingdataArr.length - 1
          ) {
            console.log(
              `Active: ${activeListings.length} : inactive: ${JSON.stringify(
                inactiveListings.length
              )}`
            );

            collectiveListings = {
              activeListings: activeListings.sort((a, b) => {
                let dateA = a.CreatedAt;
                let dateB = b.CreatedAt;

                return dateB - dateA; //For descending order
              }),

              inactiveListings: inactiveListings.sort((a, b) => {
                let dateA = a.CreatedAt;
                let dateB = b.CreatedAt;

                return dateB - dateA; //For descending order
              }),
            };
          }
        }
        dispatch({
          type: FETCH_LISTING_BY_BRANCH_SUCCESS,
          payload: collectiveListings,
        });
      } else {
        dispatch({
          type: FETCH_LISTING_BY_BRANCH_SUCCESS,
          payload: collectiveListings,
        });
      }
    });
  } catch (error) {
    dispatch({
      type: LISTING_ERROR,
      payload: `Sorry we recieved an error ,\n ${error.code} : ${error.message}`,
    });
  }
};

export const fetchUserListinghistory = (uid) => (dispatch) => (firebase) => {
  const { ListingRef, auth, api } = firebase;
  try {
    dispatch({
      type: FETCH_LISTING_START,
      payload: null,
    });

    //determines what uid to use the logged in user or the provided uid
    let DeterminedUid = uid ? uid : auth.currentUser.uid;

    ListingRef.orderByChild("userdetials/id")
      .equalTo(DeterminedUid)
      .on("value", (snapshot) => {
        let ListingHistory = snapshot.val();
        if (ListingHistory) {
          //converting data from database to an array to be used in the app
          let EnquiriesHistoryKeys = Object.keys(ListingHistory);
          let EnquiriesHistoryData = Object.values(ListingHistory);

          for (let index = 0; index < EnquiriesHistoryData.length; index++) {
            //putting the id into the object of all the element of the array
            EnquiriesHistoryData[index] = {
              ...EnquiriesHistoryData[index],
              id: EnquiriesHistoryKeys[index],
            };
          }

          dispatch({
            type: FETCH_LISTING_SUCCESS,
            payload: EnquiriesHistoryData,
          });
          dispatch(api.clearListingErrors());
        } else {
          dispatch({
            type: FETCH_LISTING_FAILED,
            payload: `No data found`,
          });
        }
      });
  } catch (error) {
    dispatch({
      type: LISTING_ERROR,
      payload: `Sorry we recieved an error ,\n ${error.code} : ${error.message}`,
    });
  }
};

export const DeleteListing =
  (deleteListingData) => (dispatch) => (firebase) => {
    //all that is required for this is a confirmation that the user wants to delete the LISTING and the id of the LISTING that the user wants to delete
    const { singleListingRef, auth } = firebase;

    try {
      dispatch({
        type: DELETE_LISTING_START,
        payload: null,
      });

      if (deleteListingData.confirmation === true) {
        singleListingRef(deleteListingData.id)
          .remove()
          .then(() => {
            dispatch({
              type: DELETE_LISTING_SUCCESS,
              payload: deleteListingData.id,
            });
          })
          .catch((error) => {
            dispatch({
              type: LISTING_ERROR,
              payload: `Sorry we recieved an error ,\n ${error.code} : ${error.message}`,
            });
          });
      } else {
        dispatch({
          type: DELETE_LISTING_FAILED,
          payload: `Did not get proper permissions to delete`,
        });
      }
    } catch (error) {
      dispatch({
        type: LISTING_ERROR,
        payload: `Sorry we recieved an error ,\n ${error.code} : ${error.message}`,
      });
    }
  };



const updateImageInListing = async (imageData, position, ListingId, refs, caption) => {

  const paddedIndex = String(position).padStart(3, "0");


  // Upload with metadata
  const metadata = {
    contentType: "image/jpeg", // e.g., "image/jpeg"
    customMetadata: {
      caption: caption
    }
  };

  const imageRef = refs.StoreListingImagesRef(
    ListingId,
    `Image${paddedIndex}`
  );

  await imageRef.put(imageData, metadata);
  const downloadUrl = await imageRef.getDownloadURL();
  console.log(`download url for image ${position}: ${downloadUrl}`);

  if (!downloadUrl || downloadUrl.startsWith("blob:")) {
    console.warn(`Skipped saving image ${position} due to invalid download URL`);
    return;
  }

  await refs.ListingImagesRef(
    ListingId,
    `Image${paddedIndex}`
  ).set(downloadUrl);

  return downloadUrl;

}



export const UpdateListingPrimary = //Added to handle the update when navigating from StaffListingInfomation to StaffUpdateWizrd, stops StaffUpdateWizrd from immediately triggering the success alert and navigating the user back
  (UpdatedListingData, pictures) => (dispatch) => async (firebase) => {
    const { singleListingRef, StoreListingImagesRef, ListingImagesRef, api, allListingImagesRef, ListingImagesCaptionRef } = firebase;

    dispatch({ type: UPDATE_LISTING_START });
    dispatch({ type: UPDATE_LISTING_INFO_START });

    if (!UpdatedListingData) {
      dispatch({
        type: UPDATE_LISTING_FAILED,
        payload: "Please double check inputted data",
      });
      return dispatch({
        type: UPDATE_LISTING_INFO_FAILED,
      });
    }


    console.log('pictures', pictures)

    let newImages = pictures.filter(x => x.new);
    let existingImages = pictures.filter(x => !x.new);

    console.log('newImages', newImages);
    console.log('existingImages', existingImages)

    try {
      // 1. Update base listing
      await singleListingRef(UpdatedListingData.id).update(UpdatedListingData);
      console.log("Updated base data")
      // 2. Handle image uploads if provided 
      try {

        //Handle Uploading existing images
        if (existingImages?.length > 0) {
          console.log("pictures.length", existingImages.length);


          await Promise.all(
            existingImages.map(async (image, index) => {
              try {
                const url = image.link;
                const res = await fetch(url);
                const arrayBuffer = await res.arrayBuffer();

                // Update the existingImages array directly
                existingImages[index] = {
                  ...image,       // keep original properties
                  data: arrayBuffer, // store downloaded bytes
                  downloaded: true
                };

                console.log(`✅ Downloaded and updated image at index ${index}`);
              } catch (err) {
                console.warn(`⚠️ Failed to download image at index ${index}:`, err.message);
              }
            })
          );

          allListingImagesRef(UpdatedListingData.id).set(null);

          await Promise.all(
            existingImages.map(async (Image, index) => {
              if (!Image.data) return;
              if (!Image.downloaded) return
              try {
                let downloadUrl = await updateImageInListing(Image.data, Image.position, UpdatedListingData.id, { ListingImagesRef, StoreListingImagesRef }, Image.caption);

                const paddedIndex = String(Image.position).padStart(3, "0");

                ListingImagesCaptionRef(UpdatedListingData.id, `Image${paddedIndex}`).set(Image.caption)

                console.log('final downloadUrl', downloadUrl)
              } catch (err) {
                console.error(`Error uploading image ${index}:`, err);
              }
            })
          );
        }


        // 2. Handle new image uploads if provided
        if (newImages.length > 0) {
          await Promise.all(
            newImages.map(async (Image, index) => {
              if (!Image.data) return;
              if (!Image.new) return;

              // Check file type BEFORE uploading
              if (!Image.data.type.startsWith("image/")) {
                console.warn(`Skipped file ${index}: not an image`);
                return;
              }

              try {
                let downloadUrl = await updateImageInListing(Image.data, Image.position, UpdatedListingData.id, { ListingImagesRef, StoreListingImagesRef }, Image.caption);

                const paddedIndex = String(Image.position).padStart(3, "0");

                ListingImagesCaptionRef(UpdatedListingData.id, `Image${paddedIndex}`).set(Image.caption)



                console.log('final downloadUrl', downloadUrl);
              } catch (err) {
                console.error(`Error uploading image ${index}:`, err);
              }

            })
          );
        }


      } catch (err) {
        console.error("Error updating listing:", err);
      }

      // 3. Fetch updated listing once
      const snapshot = await singleListingRef(UpdatedListingData.id).once("value");
      if (snapshot.exists()) {
        dispatch({
          type: UPDATE_LISTING_INFO_SUCCESS,
          payload: snapshot.val(),
        });

        dispatch(api.clearListingErrorsPrimary());
      }
    } catch (error) {
      console.error(`Update failed:`, error);
      dispatch({
        type: LISTING_ERROR,
        payload: `Error updating listing: ${error.message || error}`,
      });
    }
  };

export const UpdateListing =
  (UpdatedListingData, pictures) => (dispatch) => async (firebase) => {
    const { singleListingRef, StoreListingImagesRef, ListingImagesRef, api, allListingImagesRef } = firebase;

    dispatch({ type: UPDATE_LISTING_START });

    if (!UpdatedListingData) {
      dispatch({
        type: UPDATE_LISTING_FAILED,
        payload: "Please double check inputted data",
      });
      return;
    }

    try {
      // 1. Update base listing
      await singleListingRef(UpdatedListingData.id).update(UpdatedListingData);
      console.log("✅ Updated base listing data");

      // 2. Fetch existing images
      let dbImagesSnapshot = await allListingImagesRef(UpdatedListingData.id).once("value");
      let dbImages = dbImagesSnapshot.val() || {};
      console.log("🖼️ Existing DB images:", dbImages);
      console.log("Snapshot exists:", dbImagesSnapshot.exists());

      // Ensure pictures is an array
      let imagesToUpload = Array.isArray(pictures) ? [...pictures] : [];
      console.log("📸 Images to upload (initial):", imagesToUpload.length);

      // 3. Replace stale 'blob:' images
      if (dbImages && typeof dbImages === "object") {
        for (const [key, value] of Object.entries(dbImages)) {
          if (value?.startsWith("blob:") && imagesToUpload.length) {
            const pic = imagesToUpload.shift(); // One-to-one replacement
            const paddedIndex = String(key).padStart(3, "0");

            if (!pic || !pic.type?.startsWith("image/")) {
              console.warn(`⚠️ Skipping invalid image for ${key}`);
              continue;
            }

            try {
              const imageRef = StoreListingImagesRef(UpdatedListingData.id, key);
              await imageRef.put(pic);
              const downloadUrl = await imageRef.getDownloadURL();

              if (!downloadUrl || downloadUrl.startsWith("blob:")) {
                console.warn(`⚠️ Invalid URL for image ${key}`);
                continue;
              }

              await ListingImagesRef(UpdatedListingData.id, paddedIndex).set(downloadUrl);
              console.log(`🔁 Replaced blob image at ${key}`);
            } catch (err) {
              console.error(`❌ Error replacing image ${key}:`, err);
            }
          }
        }
      }

      // 4. Upload any remaining new images
      if (imagesToUpload.length) {
        console.log(`📤 Uploading ${imagesToUpload.length} new images...`);
        dbImagesSnapshot = await allListingImagesRef(UpdatedListingData.id).once("value");
        dbImages = dbImagesSnapshot.val() || {};
        const existingCount = Object.keys(dbImages).length;

        await Promise.all(
          imagesToUpload.map(async (pic, index) => {
            if (!pic || !pic.type?.startsWith("image/")) {
              console.warn(`⚠️ Skipping invalid image at index ${index}`);
              return;
            }

            const paddedIndex = String(existingCount + index).padStart(3, "0");
            const key = `Image${paddedIndex}`;
            const imageRef = StoreListingImagesRef(UpdatedListingData.id, key);

            try {
              await imageRef.put(pic);
              const downloadUrl = await imageRef.getDownloadURL();

              if (!downloadUrl || downloadUrl.startsWith("blob:")) {
                console.warn(`⚠️ Skipping invalid URL for image ${key}`);
                return;
              }

              await ListingImagesRef(UpdatedListingData.id, key).set(downloadUrl);
              console.log(`✅ Uploaded new image: ${key}`);
            } catch (err) {
              console.error(`❌ Error uploading new image ${key}:`, err);
            }
          })
        );
      }

      // 5. Fetch and dispatch final updated listing
      const finalSnapshot = await singleListingRef(UpdatedListingData.id).once("value");
      if (finalSnapshot.exists()) {
        dispatch({
          type: UPDATE_LISTING_SUCCESS,
          payload: finalSnapshot.val(),
        });
        dispatch(api.clearListingErrors());
        console.log("🎉 Listing successfully updated and dispatched");
      }

    } catch (error) {
      console.error("🔥 Update failed:", error);
      dispatch({
        type: LISTING_ERROR,
        payload: `Error updating listing: ${error.message || error}`,
      });
    }
  };


const fetchBroker = (userId, userIdRef) =>
  new Promise((resolve, reject) => {
    userIdRef(userId).on("value", (snapshot) => {
      let brokerInfo = snapshot.val();

      resolve(brokerInfo);
    });
  });


function normaliseGla(variable) {
  if (variable === null || variable === undefined || variable === '') {
    return null;
  }

  if (/^\d+\.\d+$/.test(variableString)) {
    return Math.floor(parseFloat(variableString));
  }

  const forbiddenChars = ['.', '#', '$', '[', ']'];
  let variableString = String(variable);

  for (const char of forbiddenChars) {
    variableString = variableString.replace(new RegExp(`\\${char}`, 'g'), '');
  }

  return variableString; // Return the modified string (without forbidden chars) or original if no changes
}

function generateWebRef(listing) {
  try {
    console.log("list.gla", listing.gla);
    console.log("listing.address.description", listing.address.description);

    let intials;
    let size;
    let addressParts;
    let areaInitials = "";
    let normalisedAreaIntials;
    let saleType;
    const unitNumber = listing?.address?.unitNumber ? listing.address.unitNumber.replace(/\s+/g, '') : "";

    if (
      !listing.userdetials &&
      !listing.userdetials.Name[0] &&
      !listing.userdetials.lastName[0]
    ) {
      return { error: true, message: "UserName Error" };
    }

    if (listing.gla <= 0 && !listing.gla) {
      return {
        error: true,
        message: "GLA size not provided or size is out of range",
      };
    }

    if (listing?.address?.description === " ") {
      return { error: true, message: "Address not provided" };
    }

    if (!listing?.type) {
      return { error: true, message: "Sale Type not provided" };
    }

    intials =
      listing.userdetials.Name[0].toUpperCase() +
      listing.userdetials.lastName[0].toUpperCase();
    size = normaliseGla(listing.gla);
    saleType = (listing?.type === "tolet" || listing?.type.includes("To Let")) ? "TL" : "FS"
    console.log(`Size: ${size}`);
    addressParts = listing.address.description.split(",");


    addressParts
      .map((area) => {
        return area
          .split(" ")
          .map((word) => (word !== "" ? word[0].toUpperCase() : ""))
          .join("");
      })
      .map((areaIntital) => (areaInitials += areaIntital));

    normalisedAreaIntials = areaInitials.replace(/[0-9]/g, "");

    let webRef = `${intials}${size}${normalisedAreaIntials}${unitNumber}${saleType}`;

    console.log(`Webref: ${webRef}`);

    return { error: false, webRefNo: webRef };
  } catch (error) {
    console.log('error', error)
    return { error: true, message: error };
  }
}

async function getPdfLinks(webRefs, multi, dispatch) {
  try {

    const webRefsFormatted = {
      webRefs: Array.isArray(webRefs) ? webRefs : [webRefs],
      multi: multi ? true : false
    };
    
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    console.log("webRefs formatted: ", webRefsFormatted)

    const raw = JSON.stringify(webRefsFormatted)

    console.log("webRefs stringified: ", raw)

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    const response = await fetch(
      `${cloud_function_server_url}/generateMultipleBrochure_GEN2`,
      requestOptions
    );
    const result = await response.json();

    if (result) {
      console.log("get pdf links response: ", result);

      const downloadUrls = result.results.map(item => item.downloadUrl);

      dispatch({
        type: GENERATE_PDF_SUCCESS,
        payload: downloadUrls,
      });
    }

  } catch (error) {
    console.log("Error generating links: ", error)
    dispatch({
        type: GENERATE_PDF_FAILED,
        payload: error,
      });
  }
}

export const generatePdfLinks = (webRefs, multi) => (dispatch) => (firebase) => {
  console.log("Webrefs: ", webRefs);

  try {

    getPdfLinks(webRefs, multi, dispatch)

  } catch (error) {
    console.log("Error getting PDF links: ", error)
    dispatch({
      type: GENERATE_PDF_FAILED,
      payload: error
    })
  }

}

export const generatePDF = (enquiry, data) => (dispatch) => (firebase) => {
  const { ListingBrochurePdfRef, StoreListingBrochureRef } = firebase;

  console.log(`In generate PDF action`);

  const createDynamicTable = (data) => {
    console.log(`creating table`);
    let Body = " ";
    let imagesHTML = " ";

    //const element = data;
    const images = Object.values(data.images);

    function populateImagesHTML(length) {
      for (let picturesIndex = 0; picturesIndex < length; picturesIndex++) {
        let element = images[picturesIndex];

        imagesHTML += `<img src=${element} alt="Thumbnail ${picturesIndex}"></img>`;
      }
    }

    if (images.length >= 8) {
      populateImagesHTML(8);
    } else {
      populateImagesHTML(images.length);
    }

    Body += `<div class="container">
      <!-- Header Section -->
      <div class="header">
          <img src="mobile-app/assets/api_prop/api_prop_brochure_images/API-logo-brochure-header" alt="API Logo">
      </div>

      <!-- Main Content Section -->
      <div class="main-content">
          <!-- Left Content -->
          <div class="property-details-price-header">
            ${data?.type === "sale"
        ? `<h1>R ${data?.price}</h1>`
        : data?.type === "To Let"
          ? `<h1>R ${data?.grossmonthlyRental} pm</h1>`
          : data?.type === "both"
            ? `<h1>R ${data?.price} / R ${data?.grossmonthlyRental} pm</h1>`
            : ""
      }
              <hr>
              <h2>
              ${data.typeOfProperty} 
              ${data?.type === "sale"
        ? `Sale`
        : data?.type === "To Let"
          ? `To Let`
          : data?.type === "both"
            ? `Sale | To Let`
            : ""
      }
              </h2>
              <hr>
              <p><strong><img src="mobile-app/assets/api_prop/api_prop_brochure_images/Property-icon.jpg" alt="Icon"> ${data.gla
      } m²</strong></p>
              <hr>
              <h3>${data?.marketingHeading}</h3>
              <p>${data?.description}</p>
              <hr>
              <div class="price-details">
                  <p><strong>
                  ${data?.type === "sale"
        ? `Sale Price: `
        : data?.type === "To Let"
          ? `Gross Monthly Rental: `
          : data?.type === "both"
            ? `Sale Price / Gross Monthly Rental: `
            : ""
      }
                    </strong> 
                  ${data?.type === "sale"
        ? `<h1>R ${data?.price}</h1>`
        : data?.type === "To Let"
          ? `<h1>R ${data?.grossmonthlyRental} pm</h1>`
          : data?.type === "both"
            ? `<h1>R ${data?.price} / R ${data?.grossmonthlyRental} pm</h1>`
            : ""
      }
                  </p>
                  ${data?.type === "To Let" || "both"
        ? `<p><strong>Lease Period: </strong> ${data?.leaseperiod ? data?.leaseperiod : " -"
        }</p>`
        : ``
      }
                  <p><strong>Available From:</strong>${data?.availability ? data?.availability : " -"
      }</p>
              </div>
              <hr>
              <div class="additional-info">
                  <table>
                      <tr>
                          <td><strong>Floor Size m²</strong></td>
                          <td>${data?.floorSize ? data?.floorSize : "-"}</td>
                          <td><strong>Security</strong></td>
                          <td>-</td>
                      </tr>
                      <tr>
                          <td><strong>Land Size m²</strong></td>
                          <td>${data?.landSize ? data?.landSize : "-"}</td>
                          <td><strong>Air Conditioning</strong></td>
                          <td>${data?.airConditioning ? data?.airConditioning : "-"
      }</td>
                      </tr>
                      <tr>
                          <td><strong>Title</strong></td>
                          <td>${data?.typeOfTitle ? data?.typeOfTitle : "-"
      }</td>
                          <td><strong>Power Amps</strong></td>
                          <td>${data?.powerAmps ? data?.powerAmps : "-"}</td>
                      </tr>
                      <tr>
                          <td><strong>Zoning</strong></td>
                          <td>${data?.zoning ? data?.zoning : "-"}</td>
                          <td><strong>Power 3 Phase</strong></td>
                          <td>${data?.power3Phase ? data?.power3Phase : "-"
      }</td>
                      </tr>
                  </table>
              </div>
              <hr>
              <div class="contact-header">
              <h3>CONTACT US</h3>
              </div>
              <div class="contact">
              <p><strong>API Property Group Agent:</strong> ${data?.userdetials?.Name
      } ${data?.userdetials?.lastName}</p>
              <p><strong>Cell:</strong> ${data?.userdetials?.mobile}</p>
              <p><strong>Email:</strong> <a href="${data?.userdetials?.email
      }">${data?.userdetials?.email}</a></p>
              <hr>
              <p><strong>Branch Office:</strong> ${enquiry?.office}</p>
              <p><strong>Phone:</strong> 021 9112906</p>
              <p><strong>Email:</strong> <a href="infoct@apiproperty.co.za">infoct@apiproperty.co.za</a></p>
          </div>
          </div>

          <!-- Right Content -->
          <div class="image-gallery">
              <div class="main-image">
                  <img src=${Object.values(data.images)[0]
      } alt="Main Property Image">
              </div>
              <div class="thumbnails">
              
              ${imagesHTML}    


              </div>
          </div>
      </div>
    <div class="footer">
            <p>${data?.web_Ref_No ? `Web Ref: ${data?.web_Ref_No}` : ``}</p>
            <p><a href="www.apiproperty.co.za">www.apiproperty.co.za</a></p>
        </div>
  </div>`;

    const html = `
    <html lang="en">
    <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Property Brochure</title>
        <style>
        body {
          font-family: Arial, sans-serif;
          margin: 0;
          padding: 0;
          background-color: #f4f4f4;
      }
      
      .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 20px;
          background: #fff;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      }
      
      .header img {
          max-width: 100%;
      }
      .hr {
        border: none;
        height: 1px;
        background-color: lightgray;
        margin: 20px 0; /* Adjust spacing around the line */
    }
    
      .main-content {
          display: flex;
          gap: 10px;
          margin-top: 10px;
      }
      
      .property-details {
          flex: 1;
      }
      
      .property-details h1 {
          color:rgb(0, 0, 0);
          font-size: 1rem;
          margin: 0;
      }
      
      .property-details h2 {
          margin: 5px 0;
      }
      
      .property-details ul {
          list-style: disc;
          margin-left: 20px;
      }
      
      .price-details, .additional-info {
          margin-top: 20px;
          color:rgb(0, 0, 0);
      }
      
      .additional-info table {
        margin: 0 auto; /* Center the table horizontally */
        border-collapse: collapse;
    }
    
    .additional-info table td {
        height: 80%;
        padding: 1px; /* Adjust padding for a more compact design */
        border: 1px solid #ddd;
        text-align: left; /* Align text to the left */
    }
    
    .additional-info table td:first-child {
        font-weight: bold; /* Make labels bold for better visibility */
    }
      
    .image-gallery {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 10px;
  }
  
  .main-image img, .thumbnails img {
      width: 100%;
      border-radius: 0px;
  }
  
  .thumbnails {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;
  }
  
      .contact-header {
      margin-top: 10px;
          background:lightgray;
          color: rgb(0, 0, 0);
          padding: 2px;
          border-radius: 0px;
      }

      .contact {
          margin-top: 10px;
          background:rgb(255, 255, 255);
          color: rgb(0, 0, 0);
          padding: 5px;
          border-radius: 0px;
      }
      
      .contact a {
          color: rgb(0, 0, 0);
          text-decoration: underline;
      }

      .footer {
    display: flex;
    justify-content: space-between;
    background-color: #1E81D3;
    color: white;
    padding: 10px;
}

.footer p {
    margin: 0;
}

.footer a {
    color: white;
}
      
        </style>
    </head>
    <body>
        ${Body}
    </body>
    </html>
`;

    return html;
  };

  async function sendListingBrochureWhatsapp(phoneNumber, listingBrochure) {
    if (phoneNumber.length < 9) {
      alert("Please insert correct WhatsApp number");
      return;
    }

    if (!phoneNumber.startsWith("+")) {
      phoneNumber = "+27" + phoneNumber;
    }

    try {
      await Linking.openURL(
        `whatsapp://send?phone=${phoneNumber.replace(
          /[^\d\+]/g,
          ""
        )}&text=${encodeURIComponent(listingBrochure)}`
      );
    } catch (error) {
      alert("Make sure Whatsapp is installed on your device");
      console.log("Error sending WhatsApp message:", error);
    }
  }

  const generate = async (data) => {
    console.log(`Generating PDF`);
    const file = await printToFileAsync({
      html: createDynamicTable(data),
      base64: false,
    });

    console.log(`uri1: ${file.uri}`);
    if (file.uri) {
      console.log(`In file.uri check statement`);
      convertPdfToBlob(file.uri);
    }
  };

  const convertPdfToBlob = async (listingPdf) => {
    const BrochureBlob = await new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.onload = function () {
        resolve(xhr.response);
      };
      xhr.onerror = function () {
        console.log("Error uploading PDF");
      };
      xhr.responseType = "blob";
      xhr.open("GET", listingPdf, true);
      xhr.send(null);
    });

    if (BrochureBlob) {
      StoreListingBrochureRef(data?.id)
        .put(BrochureBlob)
        .then(() => {
          StoreListingBrochureRef(data?.id)
            .getDownloadURL()
            .then((url) => {
              ListingBrochurePdfRef(data?.id).set(url);
              sendListingBrochureWhatsapp(enquiry?.userdetials?.mobile, url);
            });
        });

      console.log(`PDF blob created`);

      dispatch({
        type: GENERATE_PDF_SUCCESS,
        payload: null,
      });
    }
  };

  if (
    !data?.marketingHeading ||
    !data?.description ||
    !data?.gla ||
    !data?.type ||
    !data?.address
  ) {
    alert("Cannot create brochure. The listing is missing mandatory fields.");
    return;
  }

  try {
    dispatch({
      type: GENERATE_PDF_START,
      payload: null,
    });

    if (!data?.brochure) {
      generate(data);
    } else {
      dispatch({
        type: GENERATE_PDF_SUCCESS,
        payload: null,
      });
      sendListingBrochureWhatsapp(enquiry?.userdetials?.mobile, data?.brochure);
    }
  } catch (error) {
    dispatch({
      type: LISTING_ERROR,
      payload: `Sorry we recieved an error ,\n ${error.code} : ${error.message}`,
    });
  }
};

// export const duplicateListing = (originalWebRefNo) => {
//   return async (dispatch, getState, { getFirebase }) => {
//     try {
//       dispatch({ type: "DUPLICATE_LISTING_START", payload: originalWebRefNo });
//       console.log("🚀 Dispatching DUPLICATE_LISTING_START for:", originalWebRefNo);

//       const myHeaders = new Headers();
//       myHeaders.append("Content-Type", "application/json");

//       const raw = JSON.stringify({ originalWebRefNo });
//       console.log("📦 Request body:", raw);

//       const requestOptions = {
//         method: "POST",
//         headers: myHeaders,
//         body: raw,
//         redirect: "follow",
//       };

//       console.log("🌍 Calling Cloud Function duplicateListing...");
//       const response = await fetch(
//         `${cloud_function_server_url}/duplicateListing`,
//         requestOptions
//       );

//       const result = await response.json();
//       console.log("✅ Cloud Function response:", result);

//       if (!response.ok) {
//         console.error("❌ Duplication failed:", result);
//         dispatch({ type: "DUPLICATE_LISTING_FAILED", payload: result.error });
//       } else {
//         dispatch({ type: "DUPLICATE_LISTING_SUCCESS", payload: result });
//       }
//     } catch (error) {
//       console.error("💥 Error in duplicateListing thunk:", error);
//       dispatch({ type: "DUPLICATE_LISTING_FAILED", payload: error.message });
//     }
//   };
// };


export const duplicateListing = (listingData) => (dispatch) => async (firebase) => {
  dispatch({ type: DUPLICATE_LISTING_START, payload: null });
  console.log("Dispatching DUPLICATE_LISTING_START for:", listingData?.web_Ref_No);

  console.log(`original web ref: ${listingData?.web_Ref_No}`)

  // if (!originalWebRefNo) {
  //   const errorMsg = "Original Web Ref No is required";
  //   console.error("Duplication failed:", errorMsg);
  //   dispatch({ type: DUPLICATE_LISTING_FAILED, payload: errorMsg });
  //   return;
  // }

  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const raw = JSON.stringify({ listingData });
  console.log("Request body:", raw);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  try {
    console.log("🌍 Calling Cloud Function duplicateListing...");
    const response = await fetch(`${cloud_function_server_url}/duplicateListing`, requestOptions);

    const result = await response.json();
    console.log("✅ Cloud Function response:", result);

    dispatch({ type: DUPLICATE_LISTING_SUCCESS, payload: result.newListing });
  } catch (error) {
    console.error("💥 Error in duplicateListing thunk:", error);
    dispatch({ type: DUPLICATE_LISTING_FAILED, payload: error.message });
  }
};

export const CreateListing =
  (ListingData, pictures, video) => (dispatch) => async (firebase) => {
    const {
      ListingRef,
      singleListingRef,
      StoreListingImagesRef,
      ListingImagesRef,
      StoreListingVideosRef,
      ListingVideRef,
      auth,
      userIdRef,
    } = firebase;

    try {
      dispatch({
        type: CREATE_LISTING_START,
        payload: null,
      });

      if (ListingData) {
        let ErrorArray = [];
        let ownerBroker;

        if (ErrorArray.length > 0) {
          dispatch({
            type: CREATE_LISTING_FAILED,
            payload: ErrorArray,
          });
        } else {
          const brokerId = ListingData.ownerBroker ?? auth.currentUser.uid;
          ownerBroker = await fetchBroker(brokerId, userIdRef);

          console.log(`ownerBroker: ${JSON.stringify(ownerBroker)}`)

          ListingData = {
            ...ListingData,
            CreatedAt: Date.now(),

            locationSize:
              ListingData?.address?.description + ListingData?.gla
                ? ListingData?.address?.description + ListingData?.gla
                : null,
            userdetials: {
              id: ownerBroker && ListingData?.ownerBroker !== undefined ? ListingData?.ownerBroker : auth.currentUser.uid,
              email: ownerBroker ? ownerBroker?.email : auth.currentUser.email,
              agentId: ownerBroker ? (ownerBroker.agentId ?? null) : (auth.currentUser.agentId ?? null),
              PPagentId: ownerBroker ? (ownerBroker.PPagentId ?? null) : (auth.currentUser.PPagentId ?? null),
              wsAgentId: ownerBroker ? (ownerBroker.userWebId || ownerBroker.websiteID || null) : (auth.currentUser.userWebId || auth.currentUser.websiteID || null),
              mobile: ownerBroker
                ? ownerBroker?.mobile
                : auth.currentUser.profile.mobile,
              Name: ownerBroker
                ? ownerBroker?.firstName
                : auth.currentUser.profile.firstName,
              lastName: ownerBroker
                ? ownerBroker?.lastName
                : auth.currentUser.profile.lastName,
              profile: ownerBroker
                ? ownerBroker?.profile_image
                  ? ownerBroker.profile_image
                  : null
                : auth.currentUser.profile.profile_image
                  ? auth.currentUser.profile.profile_image
                  : null,
            },
          };


          let managementObject = generateWebRef(ListingData);

          if (managementObject.error === true) {
            dispatch({
              type: LISTING_ERROR,
              payload: `WebRef Error ${managementObject.message}`,
            });
            return;
          }

          const snapshot = await singleListingRef(
            managementObject.webRefNo
          ).get();

          if (!snapshot.exists()) {
            ListingData = {
              ...ListingData,
              web_Ref_No: managementObject.webRefNo,
              id: managementObject.webRefNo,
            };

            console.log(`after snapshot`);
            console.log(`listing data: ${JSON.stringify(ListingData)}`);

            singleListingRef(ListingData.web_Ref_No)
              .set(ListingData)
              .then(async (res) => {
                var id = ListingData.web_Ref_No;
                ListingData.id = id;

                if (pictures.length > 0) {
                  console.log("pictures.length", pictures.length);

                  try {
                    const uploadPromises = pictures.map(async (picture, index) => {
                      if (!picture) return;

                      const image =
                        picture?.uri ?? URL.createObjectURL(picture);

                      if (!image) return;

                      const imageBlob = await new Promise((resolve, reject) => {
                        const xhr = new XMLHttpRequest();
                        xhr.onload = function () {
                          resolve(xhr.response);
                        };
                        xhr.onerror = function () {
                          console.log("Error uploading image");
                          reject(new Error("Image fetch error"));
                        };
                        xhr.responseType = "blob";
                        xhr.open("GET", image, true);
                        xhr.send(null);
                      });

                      if (!imageBlob) return;

                      const imageRef = StoreListingImagesRef(
                        ListingData.web_Ref_No,
                        `Image${String(index).padStart(3, "0")}`
                      );

                      await imageRef.put(imageBlob);
                      console.log(`Image ${index} stored`);

                      const url = await imageRef.getDownloadURL();
                      await ListingImagesRef(
                        ListingData.web_Ref_No,
                        `Image${String(index).padStart(3, "0")}`
                      ).set(url);

                      console.log(`Image ${index} URL saved`);
                    });

                    // Wait for all uploads and saves to complete
                    await Promise.all(uploadPromises);

                    // Now that all images are uploaded and saved
                    const snapshot = await singleListingRef(ListingData.web_Ref_No).once("value");
                    if (snapshot.val()) {
                      let listing = snapshot.val();
                      dispatch({
                        type: CREATE_LISTING_SUCCESS,
                        payload: listing,
                      });
                    }
                  } catch (error) {
                    console.error("Error during image upload process:", error);
                    // Optional: dispatch failure here
                  }
                }


                if (video?.length > 0) {
                  for (let index = 0; index < video.length; index++) {
                    console.log("video.length", video.length);
                    const singleVideo = video[index]?.uri ?? null;

                    if (singleVideo) {
                      const videoblob = await new Promise((resolve, reject) => {
                        const xhr = new XMLHttpRequest();
                        xhr.onload = function () {
                          resolve(xhr.response);
                        };
                        xhr.onerror = function () {
                          console.log("Error uploading image");
                        };
                        xhr.responseType = "blob";
                        xhr.open("GET", singleVideo, true);
                        xhr.send(null);
                      });

                      if (videoblob) {
                        console.log("in video blob");
                        StoreListingVideosRef(id, `Video${index}`)
                          .put(videoblob)
                          .then(() => {
                            StoreListingVideosRef(id, `Video${index}`)
                              .getDownloadURL()
                              .then((url) => {
                                ListingVideRef(id, `Video${index}`).set(url);
                              });
                          });
                      }
                    }
                  }
                }

              })
              .catch((error) => {
                dispatch({
                  type: LISTING_ERROR,
                  payload: `Sorry we recieved an error ,\n ${error.code} : ${error.message}`,
                });
              });
          } else {
            dispatch({
              type: LISTING_ERROR,
              payload: `A Listing with the same webref already exists please check your listings`,
            });
          }
        }
      }
    } catch (error) {
      dispatch({
        type: LISTING_ERROR,
        payload: `Sorry we recieved an error ,\n ${error}`,
      });
    }
  };

export const DeleteListingPdf = (listingId) => (dispatch) => (firebase) => {
  const { StoreListingBrochureRef, ListingBrochurePdfRef } = firebase;

  try {
    dispatch({
      type: DELETE_PDF_START,
      payload: null,
    });

    if (listingId) {
      console.log(`Listing id: ${listingId}`);
      ListingBrochurePdfRef(listingId)
        .remove()
        .then(() => {
          dispatch({
            type: DELETE_PDF_SUCCESS,
            payload: none,
          });
        })
        .catch((error) => {
          dispatch({
            type: LISTING_ERROR,
            payload: `Sorry we recieved an error ,\n ${error.code} : ${error.message}`,
          });
        });

      StoreListingBrochureRef(listingId)
        .delete()
        .then(() => {
          dispatch({
            type: DELETE_PDF_SUCCESS,
            payload: none,
          });
        })
        .catch((error) => {
          dispatch({
            type: LISTING_ERROR,
            payload: `Sorry we recieved an error ,\n ${error.code} : ${error.message}`,
          });
        });
    } else {
      dispatch({
        type: DELETE_PDF_FAILED,
        payload: `Did not get proper permissions to delete`,
      });
    }
  } catch (error) {
    dispatch({
      type: LISTING_ERROR,
      payload: `Sorry we recieved an error ,\n ${error.code} : ${error.message}`,
    });
  }
};


export const uploadListingWithBrochure = (updatedListingData, pdfBlob) =>
  (dispatch) => async (firebase) => {
    try {
      // console.log("firebase object:", firebase);

      const { singleListingRef, brochureStorageRef } = firebase;
      const userId =
        firebase.auth?.currentUser?.uid || firebase.auth?.info?.uid || null;

      if (!userId) {
        throw new Error("No authenticated user found");
      }

      const listingId = updatedListingData.id;
      const brochureRef = brochureStorageRef(userId, listingId);

      // Upload the PDF
      await brochureRef.put(pdfBlob, { contentType: "application/pdf" });

      // Get the download link
      const downloadURL = await brochureRef.getDownloadURL();

      // Update Firestore
      await singleListingRef(listingId)
        .update({
          ...updatedListingData,
          BrochureUrl: downloadURL,
        })
        .then(() => {
          dispatch({
            type: UPDATE_LISTING_SUCCESS,
            payload: {
              ...updatedListingData,
              BrochureUrl: downloadURL,
            },
          });
          // alert("Here is the brochure link: " + downloadURL);
        })
        .catch((error) => {
          dispatch({
            type: LISTING_ERROR,
            payload: `Sorry we received an error,\n ${error.code} : ${error.message}`,
          });
          alert(`Error updating listing: ${error.message}`);
        });

      return downloadURL;
    } catch (error) {
      dispatch({
        type: LISTING_ERROR,
        payload: `Sorry we received an error,\n ${error.code || ""} : ${error.message || error
          }`,
      });
      alert("Error Uploading Brochure: " + error);
      return error;
    }
  };






